import request from '@/router/axios'

export function fetchCourseRewardValueStatisticsSummary (params) {
  return request({
    url: '/course/admin/analysis/course/reward-value',
    method: 'get',
    params,
  })
}

export function exportCourseRewardValueStatisticsSummary (params) {
  return request({
    url: '/course/admin/analysis/course/reward-value/export',
    method: 'get',
    params,
  })
}
